import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generateShippingClaimsCsv = {
  name: "generateShippingClaimsCsv" as const,
  input: z.object({ claimIds: z.array(zExt.objectId()) }),
  output: z.object({
    csvDataByCarrier: z.record(
      z.string(),
      z.object({ filename: z.string(), content: z.string() }),
    ),
  }),
};
